import React from 'react';

import { RightContentMenu, RightContentMenuProps } from './RightContentMenu';

interface Props extends RightContentMenuProps {}

export class RightContentMenuContainer extends React.Component<Props> {
    public render(): React.ReactNode {
        return React.createElement(RightContentMenu, {});
    }
}
